/** Thrown when the audience changed since the viewer loaded it (Connect Aborted). */ export class AudienceConflictError extends Error {
    constructor(){
        super('audience changed');
        this.name = 'AudienceConflictError';
    }
}
